import classNames from 'classnames';
import React from 'react';
import { useHabitat } from '@js/react/shared/HabitatContext';
import FormField from '@react/Eligibility/Form/FormField';
import SearchForm from '@react/Eligibility/SearchForm';
import Button from '@react/Eligibility/Button';
import { useEligibilityContext } from '@react/Eligibility/useEligibilityState';
const EligibilityInvalid = () => {
    const [{ fieldData, hasSubmitted, products, productError, searchValue }, dispatch,] = useEligibilityContext();
    const { termstext1, termstext2, culturecode } = useHabitat();
    const handleChange = (event, property) => {
        const newState = { ...fieldData };
        newState.fields[property] = event.target.value;
        dispatch({
            type: 'SET_FIELD_DATA',
            payload: newState,
        });
    };
    const handleCheckboxChange = (field) => {
        const newState = { ...fieldData };
        newState.fields[field] = !newState.fields[field];
        dispatch({
            type: 'SET_FIELD_DATA',
            payload: newState,
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        await postData(fieldData, culturecode);
        dispatch({
            type: 'SET_SUBMITTED',
            payload: true,
        });
    };
    return (React.createElement("div", { className: "ec-invalid" },
        React.createElement("div", { className: "site-wide-new" },
            React.createElement("div", { className: "ec-invalid__scroll-outer" },
                React.createElement("div", { className: "ec-invalid__scroll-inner" },
                    React.createElement(SearchForm, { initialValue: searchValue, showMessage: true, showProductMessage: productError }),
                    !hasSubmitted ? (React.createElement("form", { className: "ec-invalid__form", onSubmit: async (e) => handleSubmit(e) },
                        React.createElement("fieldset", { className: "form-group" },
                            React.createElement("legend", { className: "form-group__title" }, "Now some other details"),
                            React.createElement(FormField, { id: "employerName", label: "Your employer's full name", placeholder: "Your employer's full name", required: true, value: searchValue, disabled: true }),
                            React.createElement(FormField, { id: "fullName", label: "Your full name", placeholder: "Your full name", required: true, value: fieldData.fields.fullName, onChange: (event) => handleChange(event, 'fullName') }),
                            React.createElement(FormField, { id: "emailAddress", label: "Email address", placeholder: "Email address", required: true, value: fieldData.fields.emailAddress, onChange: (event) => handleChange(event, 'emailAddress') }),
                            React.createElement(FormField, { id: "contactNumber", label: "Contact number", placeholder: "Contact number", required: true, value: fieldData.fields.contactNumber, onChange: (event) => handleChange(event, 'contactNumber') })),
                        React.createElement("fieldset", { className: "form-group" },
                            React.createElement("legend", { className: "form-group__title" }, "Products interested in"),
                            React.createElement("div", { className: "ec-invalid__product-list" }, products.map(product => {
                                const fieldName = product.name?.replace(/\s+/g, '') ?? '';
                                const itemClassName = classNames({
                                    'ec-invalid__product': true,
                                    [`ec-invalid__product--${product.colour ?? 'ocean'}`]: true,
                                    'ec-invalid__product--selected': !!fieldData.fields[fieldName],
                                });
                                return (React.createElement("label", { key: product.name, className: itemClassName, htmlFor: product.name },
                                    React.createElement("div", { className: "ec-invalid__product-content" },
                                        React.createElement("input", { id: product.name, name: "checkbox", type: "checkbox", onChange: () => handleCheckboxChange(fieldName) }),
                                        React.createElement("span", { className: "ec-invalid__product-title" }, product.name),
                                        React.createElement("span", { className: "ec-invalid__product-summary" }, product.subTitle)),
                                    React.createElement("img", { className: "ec-invalid__product-image", src: product.image, alt: "" })));
                            })),
                            React.createElement("small", { className: "ec-invalid__terms" }, termstext1),
                            React.createElement("small", { className: "ec-invalid__terms" }, termstext2)),
                        React.createElement(Button, { text: "Submit Interest" }))) : (React.createElement("div", { className: "eligibility-form__invalid-submitted" }, "Thank you for submitting your enquiry")))))));
};
export default EligibilityInvalid;
async function postData(fieldData, cultureCode) {
    const res = await fetch(`/umbraco/api/employersapi/PostEnquiry?cultureCode=${cultureCode}`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(fieldData.fields),
    });
    if (!res.ok) {
        return;
    }
}
